import React from 'react';
import { modalViewGA } from '../../../utils/googleAnalytics';
import MessagePartnerForm from '../../Forms/MessagePartner';

class MessagePartnerModal extends React.Component {
  constructor(props){
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.toolTip = this.toolTip.bind(this);
    this.state = {
      submitted: false
    };
  }

  componentDidMount(){
    modalViewGA('message-partner-modal');
  }

  closeModal(e){
    e.preventDefault();
    this.props.removeModal();
  }

  toolTip(e){
    e.preventDefault();
  }

  render(){
    let FormDisplay = (this.props.submitted) ? (
      <p>Thank you for your message!</p>
    ) : (
      <MessagePartnerForm
        removeModal={this.props.removeModal}
        partnerId={this.props.partnerId}
        livecamId={this.props.livecamId}
        partnerTitle={this.props.partnerTitle}
      />
      );
    return (
      <div>
        <div className="modals-popup feedback-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Message a partner</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={(e)=>{this.closeModal(e)}}></a>
            </div>
          </div>

          <div className="info">
          <div className="p-20">
            {FormDisplay}
          </div>
          </div>

        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
  };
}


export default MessagePartnerModal;
